function getHashFilter() {
  var matches = location.hash.match(/filter=([^&]+)/i);
  var hashFilter = matches && matches[1];
  return hashFilter && decodeURIComponent(hashFilter);
}

function getCurrentHtmlLangCode() {
  return document.getElementsByTagName('html')[0].getAttribute('lang');
}

function getMomentRanges() {
  let ranges;
  if (getCurrentHtmlLangCode() === 'fi') {
    ranges = {
      Tänään: [moment(), moment()],
      Huomenna: [moment().add(1, 'days'), moment().add(1, 'days')],
      'Tämä kuukausi': [moment().startOf('month'), moment().endOf('month')],
    };
  } else if (
    getCurrentHtmlLangCode() === 'en-GB' ||
    getCurrentHtmlLangCode() === 'en-US' ||
    getCurrentHtmlLangCode() === 'en'
  ) {
    ranges = {
      Today: [moment(), moment()],
      Tomorrow: [moment().add(1, 'days'), moment().add(1, 'days')],
      'This month': [moment().startOf('month'), moment().endOf('month')],
    };
  }
  return ranges;
}

function getCalendarLocale() {
  let locales;
  if (getCurrentHtmlLangCode() === 'fi') {
    locales = {
      format: 'DD.MM.YYYY',
      separator: ' - ',
      applyLabel: 'Hyväksy',
      cancelLabel: 'Peruuta',
      fromLabel: 'Alkaen',
      toLabel: 'Päättyen',
      customRangeLabel: 'Custom',
      weekLabel: 'W',
      daysOfWeek: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
      monthNames: [
        'Tammikuu',
        'Helmikuu',
        'Maaliskuu',
        'Huhtikuu',
        'Toukokuu',
        'Kesäkuu',
        'Heinäkuu',
        'Elokuu',
        'Syyskuu',
        'Lokakuu',
        'Marraskuu',
        'Joulukuu',
      ],
      firstDay: 1,
    };
  }
  return locales;
}

(function ($) {
  // init Isotope
  let filters = {};
  var $grid = $('.kemijarvi-events-list__container').isotope({
    itemSelector: '.kemijarvi-events-list__card',
    transitionDuration: '0s',
  });

  let isIsotopeInit = false;
  let filterStartDate, filterEndDate, startdate_formatted, enddate_formatted;
  let filterClass = '*';

  $('input[name="event-pick-date"]').daterangepicker(
    {
      ranges: getMomentRanges(),
      locale: getCalendarLocale(),
      autoUpdateInput: false,
      showCustomRangeLabel: false,
      alwaysShowCalendars: true,
      startDate: moment(),
      endDate: moment(),
      minDate: moment(),
    },
    function (start, end, label) {
      let today = moment().format('DD.MM.YYYY').toString();
      //let tomorrow = moment().add(1, 'days').format('DD.MM.YYYY').toString();

      filterStartDate = start.format('YYYYMMDD');
      filterEndDate = end.format('YYYYMMDD');
      startdate_formatted = start.format('DD.MM.YYYY');
      enddate_formatted = end.format('DD.MM.YYYY');

      let date_selected =
        'Näytetään tapahtumat ajalta: ' +
        start.format('DD.MM.YYYY') +
        ' - ' +
        end.format('DD.MM.YYYY');

      if (getCurrentHtmlLangCode() === 'fi') {
      } else if (
        getCurrentHtmlLangCode() === 'en-GB' ||
        getCurrentHtmlLangCode() === 'en-US' ||
        getCurrentHtmlLangCode() === 'en'
      ) {
        date_selected =
          'Events between: ' +
          start.format('DD.MM.YYYY') +
          ' and ' +
          end.format('DD.MM.YYYY');
      }

      if (startdate_formatted == enddate_formatted) {
        if (startdate_formatted == today) {
          date_selected = 'Näytetään tapahtumat tänään.';
          if (getCurrentHtmlLangCode() === 'fi') {
          } else if (
            getCurrentHtmlLangCode() === 'en-GB' ||
            getCurrentHtmlLangCode() === 'en-US' ||
            getCurrentHtmlLangCode() === 'en'
          ) {
            date_selected = 'Events today.';
          }
        } else {
          date_selected = 'Näytetään tapahtumat huomenna.';
          if (getCurrentHtmlLangCode() === 'fi') {
          } else if (
            getCurrentHtmlLangCode() === 'en-GB' ||
            getCurrentHtmlLangCode() === 'en-US' ||
            getCurrentHtmlLangCode() === 'en'
          ) {
            date_selected = 'Events tomorrow.';
          }
        }
      }

      $('.events-filter__date-selected-info').text(date_selected);

      //window.location.search += '&startday=' + start.format('DD.MM.YYYY');

      combinedFilter();

      // $grid.isotope({
      //   filter: function () {
      //     let eventStartDate = $(this).data('startdate');
      //     let eventEndDate = $(this).data('enddate');

      //     return (
      //       (eventStartDate >= filterStartDate &&
      //         eventStartDate <= filterEndDate) ||
      //       (eventEndDate >= filterStartDate &&
      //         eventEndDate <= filterEndDate) ||
      //       (eventStartDate <= filterStartDate && eventEndDate >= filterEndDate)
      //     );
      //   },
      // });
    }
  );

  // Function to check if Isotope grid is empty
  function isIsotopeEmpty() {
    var filteredItems = $grid.data('isotope').filteredItems;
    return filteredItems.length === 0;
  }

  function combinedFilter() {
    filterClass = filterClass.replace('.', '');
    $grid.isotope({
      filter: function () {
        let eventStartDate = $(this).data('startdate');
        let eventEndDate = $(this).data('enddate');

        if (filterStartDate && filterEndDate) {
          return (
            ((eventStartDate >= filterStartDate &&
              eventStartDate <= filterEndDate) ||
              (eventEndDate >= filterStartDate &&
                eventEndDate <= filterEndDate) ||
              (eventStartDate <= filterStartDate &&
                eventEndDate >= filterEndDate)) &&
            ($(this).hasClass(filterClass) || filterClass == '*')
          );
        } else {
          return $(this).hasClass(filterClass) || filterClass == '*';
        }
      },
    });

    if (isIsotopeEmpty()) {
      $('.no-posts-msg').show();
    } else {
      $('.no-posts-msg').hide();
    }
  }

  // filter items on button click
  // change is-checked class on buttons
  $('.events-filter-types').each(function (i, buttonGroup) {
    var $buttonGroup = $(buttonGroup);

    $buttonGroup.on('click', 'button', function () {
      $buttonGroup.find('.active-term').removeClass('active-term');
      $(this).addClass('active-term');

      var filterValue = $(this).attr('data-filter');
      filterClass = filterValue;
      location.hash = 'filter=' + encodeURIComponent(filterValue);

      combinedFilter();
    });
  });

  function onHashchange() {
    var hashFilter = getHashFilter();
    if (null === hashFilter || isIsotopeInit) {
      return;
    }
    isIsotopeInit = true;

    // set selected class on button
    if (hashFilter) {
      filterClass = hashFilter;

      $('.events-filter-types button.show-all-terms').removeClass(
        'active-term'
      );

      $('.events-filter-types button').each(function (i, button) {
        var $button = $(button);
        $button.find('.show-all-terms').removeClass('active-term');

        let $active = $button.filter('[data-filter="' + hashFilter + '"]');
        $active.addClass('active-term');
      });

      combinedFilter();
    }
  }

  // trigger event handler to init Isotope
  onHashchange();
})(jQuery);
